// https://stackoverflow.com/a/77277034
export async function downloadPost(url: string, body: any = {}, filename?: string) {
  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (response.ok) {
    const actualFileName =
      filename ?? response.headers.get('Content-Disposition')?.split('filename=')[1] ?? 'unnamed_file';
    const blob = await response.blob();
    const download = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = download;
    a.download = actualFileName;
    a.click();
  } else {
    throw new Error("We're not sure what went wrong. Please try again later.");
  }
}
